﻿export const AppModalHvorLengeContainerId = 'hvorlenge';
export const AppModalOmStudieplassContainerId = 'omstudieplass';
export const AppModalOmPermisjonContainerId = 'ompermisjon';
export const AppModalOmNavContainerId = 'omnav';
export const AppModalErStudentContainerId = 'erstudent';
export const AppModalOmNarJegKanSokeContainerId = 'omnarjegkansoke';
